import React, { useState } from 'react';
import cn from 'classnames';
import MoreButton from 'generic/MoreButton';
import { SearchTabContainer } from './SearchTabStyles';

const SearchTab = ({ children, countHideFilledFields, isShow = true, isProposals = false }) => {
  const [isShowAllFilters, setShowAllFilters] = useState(false);
  const formClassNames = cn(!isShowAllFilters && 'is-hide', isProposals && 'proposals');

  return (
    <SearchTabContainer>
      <form className={formClassNames}>{children}</form>
      {isShow && (
        <div className="more-btn">
          <MoreButton
            openText={
              countHideFilledFields ? `Все параметры (${countHideFilledFields})` : 'Все параметры'
            }
            closeText="Скрыть параметры"
            handleClick={() => setShowAllFilters(!isShowAllFilters)}
          />
        </div>
      )}
    </SearchTabContainer>
  );
};

export default SearchTab;
